import SupportManager from '../../layout/admin/SupportManager';

export default function Support() {
  return (
    <>
      <div className="flex-colomn gap-2">
        <SupportManager />
      </div>
    </>
  );
}
